import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { marketStats } from '../../data/mockData';

const MarketStatsSection = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % marketStats.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-gradient-to-r from-[#12532c] via-[#12532c] to-[#12532c] py-6 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
            <span className="text-emerald-300 font-semibold text-sm">
              {t({ en: 'Live Market Intelligence', ar: 'معلومات السوق المباشرة' })} • {t({ en: 'Updated Quarterly', ar: 'تحديث ربع سنوي' })}
            </span>
          </div>
          <div className="hidden md:grid grid-cols-4 gap-8">
            {marketStats.map((stat) => (
              <div key={stat.id} className="text-center">
                <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                <div className="text-xs text-[#C5A038]">{t(stat.label)}</div>
                <div className="text-xs text-emerald-200/70 mt-1">{t(stat.source)}</div>
              </div>
            ))}
          </div>
          {/* Mobile Carousel */}
          <div className="md:hidden flex-1 mx-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-white mb-1">{marketStats[currentIndex].value}</div>
              <div className="text-xs text-[#C5A038]">{t(marketStats[currentIndex].label)}</div>
              <div className="text-xs text-emerald-200/70 mt-1">{t(marketStats[currentIndex].source)}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketStatsSection;
